import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useNotificationUtils() {
    var _a = React.useState(), notificationElement = _a[0], setNotificationElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || notificationElement)
            return;
        var loadedNotificationElement = client.getNotificationElement();
        setNotificationElement(loadedNotificationElement);
    }, [client, setNotificationElement, notificationElement]);
    return notificationElement;
}
export function useNotificationsData() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData))
            return;
        var subscription = notificationElement.getNotificationsData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData]);
    return data;
}
export function useUnreadNotificationsCount() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState({ forYou: null, all: null }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount))
            return;
        var subscription = notificationElement.getUnreadNotificationsCount().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount]);
    return data;
}
